import { simpleLookupConfig } from "../../../../records/lookup/config/simpleLookupConfig";
import { vsLookupManagementServiceProviderName } from "../../../shared/lookups";

export const vsObjectName = "coinDivision";

const coinDivisionUrl = "/api/machines/CoinDivision";

export const coinDivisionLookupConfig = simpleLookupConfig(
  vsLookupManagementServiceProviderName,
  {
    name: vsObjectName,
    nameSingular: "Coin Division",
    url: coinDivisionUrl,
  }
);
